import angular from 'angular';

let zipCodeValidator = () => ({
  require: 'ngModel',
  link(scope, element, atts, ctrl) {
    return (ctrl.$validators.zipCode = (modelValue, viewValue) =>
      /^(\d{5}-\d{4}|\d{5})$/.test(viewValue));
  },
});

export default angular
  .module('app.validators.zipCode', [])
  .directive('zipCode', zipCodeValidator);
